import React from 'react';
import { Section } from '@layout';
import { H2 } from '@heading';
import { Button } from '@input';
import styles from './Awards.module.scss';

export default function Awards() {
  return (
    <Section contentClassName={styles.wrapper}>
      <div className={styles.title}>
        <H2>
          <span>Honors &amp; awards</span>
        </H2>
      </div>
      <p>
        Aradhna has received numerous awards for her research, education,
        and outreach programs including a Presidential Early Career Award
        in Science and Engineering from President Obama.
      </p>
      <Button
        to="/about/honors-and-awards"
        icon="atom"
      >
        View honors and awards
      </Button>
    </Section>
  );
}
